// Shopping deep-link builder for furniture recommendations.
//
// We don't fetch product data ourselves — we just build a search URL that
// opens the user's preferred marketplace (Naver Shopping for Korean, Google
// Shopping otherwise). This keeps results live (the marketplace handles
// freshness, ranking, regional pricing) and adds zero API cost or rate limits.
//
// Future enhancement (deferred): call Naver Shopping API / Google Shopping API
// directly to embed actual product cards with current price/stock. Worth
// considering once we see how often users actually click through.

const NAVER_SHOPPING = 'https://search.shopping.naver.com/search/all';
const GOOGLE_SHOPPING = 'https://www.google.com/search';

// Strip Markdown formatting tokens (** _ ` etc.) and collapse whitespace.
// AI furniture descriptions sometimes leak markdown — those characters
// pollute search queries.
function cleanQuery(text) {
  if (!text || typeof text !== 'string') return '';
  return text
    .replace(/[*_`~#]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function buildShoppingUrl(itemText, lang = 'en') {
  const q = cleanQuery(itemText);
  if (!q) return null;
  if (lang === 'ko') {
    return `${NAVER_SHOPPING}?query=${encodeURIComponent(q)}`;
  }
  return `${GOOGLE_SHOPPING}?tbm=shop&q=${encodeURIComponent(q)}`;
}

export function shoppingProvider(lang = 'en') {
  return lang === 'ko' ? 'naver' : 'google';
}
